import * as EdeliveryActions from './lib/+state/e-delivery-terms-and-conditions.actions';
import * as EdeliverySelectors from './lib/+state/e-delivery-terms-and-conditions.selectors';

export { EdeliverySelectors, EdeliveryActions };

export * from './lib/policy-e-delivery-data-access.module';
